import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  useEffect(() => {
    // Set page title and meta description
    document.title = '会社概要｜24年の実績と信頼｜おかやま不動産販売株式会社';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'おかやま不動産販売株式会社の会社概要。2000年創業、岡山市で24年の実績。地域密着型の不動産サービスで、お客様の信頼にお応えします。');
    }

    // Add structured data
    const structuredData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#organization`,
          "name": "おかやま不動産販売株式会社",
          "url": import.meta.env.VITE_SITE_URL || 'https://example.com',
          "logo": {
            "@type": "ImageObject",
            "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/logo.png`
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "○○町1-2-3",
            "addressLocality": "岡山市北区",
            "addressRegion": "岡山県",
            "postalCode": "700-0000",
            "addressCountry": "JP"
          },
          "telephone": "086-012-3456",
          "faxNumber": "086-012-3457",
          "foundingDate": "2000",
          "numberOfEmployees": "5",
          "description": "岡山市を中心に不動産売買・買取サービスを提供する地域密着型の不動産会社"
        },
        {
          "@type": "WebPage",
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about#webpage`,
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
          "name": "会社概要｜おかやま不動産販売株式会社",
          "description": "おかやま不動産販売株式会社の会社概要と沿革",
          "isPartOf": {
            "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#website`
          }
        }
      ]
    };

    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector('script[type="application/ld+json"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  const companyInfo = [
    { label: '会社名', value: 'おかやま不動産販売株式会社' },
    { label: '代表取締役', value: '岡山 太郎' },
    { label: '設立', value: '2000年' },
    { label: '従業員数', value: '5名' },
    { label: '所在地', value: '〒700-0000 岡山市北区○○町1-2-3' },
    { label: '電話番号', value: '086-012-3456' },
    { label: 'FAX番号', value: '086-012-3457' },
    { label: '営業時間', value: '9:00〜18:00' },
    { label: '定休日', value: '日曜日・祝日' }
  ];

  const licenses = [
    '宅地建物取引業免許 岡山県知事(5)第○○○○号',
    '公益社団法人 岡山県宅地建物取引業協会 会員',
    '公益社団法人 全国宅地建物取引業保証協会 会員',
    '一般社団法人 岡山県不動産鑑定士協会 賛助会員'
  ];

  const history = [
    { year: '2000年', event: 'おかやま不動産販売株式会社設立' },
    { year: '2002年', event: '岡山県宅地建物取引業協会加入' },
    { year: '2005年', event: '買取事業部門を新設' },
    { year: '2010年', event: '従業員数5名体制を確立' },
    { year: '2015年', event: '累計取引件数1,000件突破' },
    { year: '2020年', event: '創業20周年を迎える' },
    { year: '2024年', event: '累計取引件数2,000件突破'  }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="relative py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">会社概要</h1>
              <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
                地域密着20年の実績で、お客様の不動産取引をサポート
              </p>
            </div>
          </div>
        </section>

        {/* Company Message */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">代表メッセージ</h2>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  おかやま不動産販売株式会社は、2000年の設立以来、岡山市を中心とした地域で不動産売買・買取事業を展開してまいりました。
                </p>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  私たちは「お客様第一」の理念のもと、一人ひとりのお客様に寄り添い、最適な不動産取引をサポートすることが使命としております。地域に根ざした豊富な経験と専門知識を活かし、安心・安全な取引をお約束いたします。
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  今後も地域の皆様に愛され、信頼される不動産会社として、より一層のサービス向上に努めてまいります。
                </p>
                <div className="mt-8">
                  <p className="text-xl font-semibold text-gray-900">代表取締役　岡山 太郎</p>
                </div>
              </div>
              <div>
                <img
                  src="https://public.readdy.ai/ai/img_res/924baeda2544fe94261881cc3b1562e3.jpg"
                  alt="代表取締役 岡山太郎"
                  className="w-full h-96 object-cover object-top rounded-xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Company Info */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                会社情報
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div className="bg-white rounded-xl shadow-lg p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">基本情報</h3>
                <div className="space-y-4">
                  {companyInfo.map((info, index) => (
                    <div key={index} className="flex border-b border-gray-100 pb-3">
                      <dt className="w-32 text-gray-600 font-medium">{info.label}</dt>
                      <dd className="flex-1 text-gray-900">{info.value}</dd>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">許可・資格・加入団体</h3>
                <div className="space-y-4">
                  {licenses.map((license, index) => (
                    <div key={index} className="flex items-start">
                      <i className="ri-check-line text-blue-600 mr-3 mt-1"></i>
                      <span className="text-gray-700 leading-relaxed">{license}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Company History */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                沿革
              </h2>
              <p className="text-xl text-gray-600">
                創業から現在まで、地域と共に歩んできた歴史
              </p>
            </div>

            <div className="relative">
              <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-blue-200"></div>
              <div className="space-y-8">
                {history.map((item, index) => (
                  <div key={index} className="relative flex items-start">
                    <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white text-sm font-bold relative z-10">
                      {index + 1}
                    </div>
                    <div className="ml-6 bg-white rounded-lg shadow-md p-6 flex-1">
                      <div className="flex flex-col md:flex-row md:items-center">
                        <span className="text-blue-600 font-bold text-lg mb-2 md:mb-0 md:mr-4">
                          {item.year}
                        </span>
                        <span className="text-gray-900 text-lg">{item.event}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Office Image */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                オフィス
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20Japanese%20commercial%20building%20with%20clean%20white%20and%20gray%20exterior%20walls%2C%20large%20glass%20windows%20reflecting%20natural%20light%2C%20professional%20business%20entrance%20with%20automatic%20sliding%20doors%2C%20urban%20setting%20with%20well-maintained%20landscaping%2C%20contemporary%20architectural%20design%20without%20any%20text%20or%20signage%20visible&width=600&height=400&seq=office-exterior-updated&orientation=landscape"
                alt="オフィス外観"
                className="w-full h-64 object-cover object-top rounded-xl shadow-lg"
              />
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20Japanese%20office%20interior%20with%20consultation%20desks%2C%20comfortable%20seating%20area%2C%20bright%20lighting%2C%20professional%20atmosphere%2C%20real%20estate%20office%20design%2C%20welcoming%20environment&width=600&height=400&seq=office-interior&orientation=landscape"
                alt="オフィス内観"
                className="w-full h-64 object-cover object-top rounded-xl shadow-lg"
              />
            </div>
          </div>
        </section>

        {/* Access Map */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                アクセス
              </h2>
            </div>
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.8!2d133.9341!3d34.6617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDM5JzQyLjEiTiAxMzPCsDU2JzAyLjgiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="おかやま不動産販売株式会社の地図"
              ></iframe>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
